/* Carbon Autohaus - sidebar filter enhancements
 * 1. Model options nest under their own Vehicle Make, read from "Make:Model" tags
 * 2. Any option list longer than SHOW_LIMIT becomes a scrolling column immediately
 * 3. Search box filters every option in the sidebar
 * 4. Placeholder for product cards with no image
 */
(function () {
  'use strict';

  var SHOW_LIMIT = 10;   // more options than this -> scrolling column, no "Show More"
  var LIST_MAX   = 420;  // px, height of a scrolling filter group
  var NEST_MAX   = 260;  // px, height of the nested model list

  var MAKE_FILTER = 'filter.p.m.custom.vehicle_make_2';
  var TAG_FILTER  = 'filter.p.tag';

  var uid = 0;
  var query = '';

  function sidebar() { return document.querySelector('.page-layout-sidebar'); }

  function facet(name) {
    var sb = sidebar();
    return sb ? sb.querySelector('.js-filter[data-name="' + name + '"]') : null;
  }

  function labelOf(li) {
    var t = li.querySelector('.checkbox-facet-label-text');
    return t ? t.textContent.trim() : li.textContent.trim();
  }

  /* "Porsche:911" -> {make:"Porsche", label:"911"}; anything else -> null */
  function resolve(value) {
    if (!value) return null;
    var c = value.indexOf(':');
    if (c < 1 || c === value.length - 1) return null;
    return { make: value.slice(0, c).trim(), label: value.slice(c + 1).trim() };
  }

  function styles() {
    if (document.getElementById('cah-filters-css')) return;
    var s = document.createElement('style');
    s.id = 'cah-filters-css';
    s.textContent = [
      '.cah-hidden{display:none !important}',
      '.page-layout-sidebar .facet-options-list.cah-scroll{max-height:' + LIST_MAX + 'px;overflow-y:auto;overscroll-behavior:contain;padding-right:6px}',
      '.cah-nest{margin:6px 0 4px 28px;padding-left:12px;border-left:2px solid rgba(128,128,128,.35)}',
      '.cah-nest>ul{list-style:none;margin:0;padding:0}',
      '.cah-nest>ul.cah-scroll-nest{max-height:' + NEST_MAX + 'px;overflow-y:auto;overscroll-behavior:contain;padding-right:6px}',
      '.cah-search{position:relative;margin:0 0 18px}',
      '.cah-search input{width:100%;box-sizing:border-box;padding:9px 30px 9px 11px;font:inherit;font-size:14px;line-height:1.3;border:1px solid rgba(128,128,128,.45);border-radius:4px;background:transparent;color:inherit}',
      '.cah-search input:focus{outline:none;border-color:currentColor}',
      '.cah-search-clear{position:absolute;top:50%;right:4px;transform:translateY(-50%);width:24px;height:24px;line-height:1;font-size:18px;border:0;background:none;color:inherit;opacity:.55;cursor:pointer;display:none}',
      '.cah-search.has-value .cah-search-clear{display:block}',
      '.cah-search-none{margin:10px 2px 0;font-size:13px;opacity:.7}',
      /* placeholder for product cards with no image */
      '.card-product.card-no-media .card-media{position:relative;display:block;width:100%;padding-top:125%;background:rgba(128,128,128,.07);overflow:hidden}',
      '.card-product.card-no-media .card-media>a{position:absolute;top:0;right:0;bottom:0;left:0;display:block}',
      '.card-product.card-no-media .card-media::before{content:"";position:absolute;top:50%;left:50%;width:46px;height:46px;transform:translate(-50%,calc(-50% - 12px));background:url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23b0b0b0%27 stroke-width=%271.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Crect x=%273%27 y=%274.5%27 width=%2718%27 height=%2715%27 rx=%272%27/%3E%3Ccircle cx=%278.5%27 cy=%2710%27 r=%271.6%27/%3E%3Cpath d=%27M21 15.5l-4.8-4.8L11 16l-2.4-2.4L3 19%27/%3E%3C/svg%3E") center/contain no-repeat;opacity:.75;pointer-events:none}',
      '.card-product.card-no-media .card-media::after{content:"No photo";position:absolute;top:50%;left:0;right:0;transform:translateY(22px);text-align:center;font-size:11px;letter-spacing:.14em;text-transform:uppercase;color:rgba(120,120,120,.85);pointer-events:none}'
    ].join('');
    document.head.appendChild(s);
  }

  /* ---------- 1. nest models under their own make ---------- */
  function buildNest() {
    var mf = facet(MAKE_FILTER);
    var tf = facet(TAG_FILTER);
    if (!mf || !tf || mf.querySelector('.cah-nest')) return;

    var checked = [].slice.call(mf.querySelectorAll('li.facet-options-list-item'))
      .filter(function (li) {
        var i = li.querySelector('input[type=checkbox]');
        return i && i.checked;
      });
    if (!checked.length) return;

    var byMake = {};
    [].forEach.call(tf.querySelectorAll('li.facet-options-list-item'), function (li) {
      var r = resolve(labelOf(li));
      if (!r) return;
      var k = r.make.toLowerCase();
      (byMake[k] = byMake[k] || []).push({ li: li, label: r.label });
    });

    checked.forEach(function (makeLi) {
      var list = byMake[labelOf(makeLi).toLowerCase()];
      if (!list || !list.length) return;

      var wrap = document.createElement('div');
      wrap.className = 'cah-nest';
      var ul = document.createElement('ul');
      wrap.appendChild(ul);

      list.forEach(function (o) {
        var input = o.li.querySelector('input[type=checkbox]');
        var label = o.li.querySelector('label');
        if (input && label) {
          var id = 'cah-m-' + (uid++);
          input.id = id;
          label.setAttribute('for', id);
        }
        var txt = o.li.querySelector('.checkbox-facet-label-text');
        if (txt) txt.textContent = o.label;          // drop the "Make:" prefix
        o.li.classList.add('cah-model');
        ul.appendChild(o.li);
      });

      if (list.length > SHOW_LIMIT) ul.className = 'cah-scroll-nest';
      makeLi.appendChild(wrap);
    });
  }

  /* ---------- remove anything nested under the wrong make ---------- */
  function prune() {
    var mf = facet(MAKE_FILTER);
    if (!mf) return;
    [].forEach.call(mf.querySelectorAll('li li'), function (li) {
      if (li.classList.contains('cah-model')) return;
      var parent = li.parentElement ? li.parentElement.closest('li') : null;
      if (!parent) return;
      var r = resolve(labelOf(li));
      if (!r || r.make.toLowerCase() !== labelOf(parent).toLowerCase()) {
        li.remove();
        return;
      }
      var txt = li.querySelector('.checkbox-facet-label-text');
      if (txt) txt.textContent = r.label;
      li.classList.add('cah-model');
    });
  }

  /* ---------- 2. scrolling column as soon as a list is long ---------- */
  function applyScroll() {
    var sb = sidebar();
    if (!sb) return;
    [].forEach.call(sb.querySelectorAll('.facet-options-list'), function (ul) {
      if (ul.querySelectorAll(':scope > li').length <= SHOW_LIMIT) return;
      ul.setAttribute('aria-expanded', 'true');
      ul.classList.add('cah-scroll');
      var f = ul.closest('.facet');
      var more = f && f.querySelector('.facet-button-more');
      if (more) more.classList.add('cah-hidden');
    });
  }

  /* ---------- 3. search ---------- */
  function buildSearch() {
    var sb = sidebar();
    if (!sb || sb.querySelector('.cah-search')) return;
    var host = sb.querySelector('.page-layout-sidebar-inner-content') || sb;

    var box = document.createElement('div');
    box.className = 'cah-search';

    var input = document.createElement('input');
    input.type = 'search';
    input.placeholder = 'Search filters…';
    input.setAttribute('aria-label', 'Search filters');
    input.setAttribute('autocomplete', 'off');
    input.value = query;

    var clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'cah-search-clear';
    clear.setAttribute('aria-label', 'Clear search');
    clear.textContent = '×';

    var none = document.createElement('p');
    none.className = 'cah-search-none cah-hidden';
    none.textContent = 'No matching filters';

    box.appendChild(input);
    box.appendChild(clear);
    box.appendChild(none);
    host.insertBefore(box, host.firstChild);

    input.addEventListener('input', function () { runSearch(input.value); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') e.preventDefault();
      if (e.key === 'Escape') { input.value = ''; runSearch(''); }
    });
    clear.addEventListener('click', function () {
      input.value = '';
      runSearch('');
      input.focus();
    });

    if (query) runSearch(query);
  }

  function runSearch(value) {
    query = (value || '').trim();
    var q = query.toLowerCase();
    var sb = sidebar();
    if (!sb) return;

    var box = sb.querySelector('.cah-search');
    if (box) box.classList.toggle('has-value', !!q);

    [].forEach.call(sb.querySelectorAll('.cah-model'), function (li) {
      li.classList.toggle('cah-hidden', !!q && labelOf(li).toLowerCase().indexOf(q) === -1);
    });

    [].forEach.call(sb.querySelectorAll('li.facet-options-list-item'), function (li) {
      if (li.classList.contains('cah-model')) return;
      var hit = !q ||
        labelOf(li).toLowerCase().indexOf(q) > -1 ||
        !!li.querySelector('.cah-model:not(.cah-hidden)');
      li.classList.toggle('cah-hidden', !hit);
    });

    var visible = 0;
    [].forEach.call(sb.querySelectorAll('.js-filter'), function (f) {
      var has = !!f.querySelector('li.facet-options-list-item:not(.cah-hidden)');
      f.classList.toggle('cah-hidden', !!q && !has);
      if (!q || has) visible++;
      if (q) {
        var ul = f.querySelector('.facet-options-list');
        if (ul) ul.setAttribute('aria-expanded', 'true');
      }
    });

    var none = sb.querySelector('.cah-search-none');
    if (none) none.classList.toggle('cah-hidden', !q || visible > 0);
  }

  /* ---------- run ---------- */
  var timer;
  function apply() {
    styles();
    if (!sidebar()) return;
    buildNest();
    prune();
    applyScroll();
    buildSearch();
    if (query) runSearch(query);
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(apply, 80);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();